import { render, staticRenderFns } from "./AddAllIndiaMockTest.vue?vue&type=template&id=3ea70e94&scoped=true"
import script from "./AddAllIndiaMockTest.vue?vue&type=script&lang=js"
export * from "./AddAllIndiaMockTest.vue?vue&type=script&lang=js"
import style0 from "./AddAllIndiaMockTest.vue?vue&type=style&index=0&id=3ea70e94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea70e94",
  null
  
)

export default component.exports